import { render, staticRenderFns } from "./CockpitLoader.vue?vue&type=template&id=3c5658ee&scoped=true"
import script from "./CockpitLoader.vue?vue&type=script&lang=js"
export * from "./CockpitLoader.vue?vue&type=script&lang=js"
import style0 from "./CockpitLoader.vue?vue&type=style&index=0&id=3c5658ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c5658ee",
  null
  
)

export default component.exports